<template>
    <div class="infoRegForm">
        <div class="info">
            <div class="info-box">
                <div class="title-box">重庆医科大学高等学历继续教育学生入学信息登记表</div>
                <!-- label-width="80px" -->
                <el-form 
                    ref="form" 
                    :model="formData" 
                    :rules="rules"
                >
                    <div class="info-floor">
                        <div class="item">
                            <span class="name">学号:</span>
                            <el-input class="input" v-model="userInfo.student_code" readonly placeholder=""></el-input>
                        </div>
                        <div class="item">
                            <span class="name">年级:</span>
                            <el-input class="input" v-model="userInfo.grade" readonly placeholder=""></el-input>
                        </div>
                        <div class="item">
                            <span class="name">学习形式:</span>
                            <el-input class="input" v-model="userInfo.study_form_title" readonly placeholder=""></el-input>
                        </div>
                    </div>
                    <div class="info-floor">
                        <div class="item">
                            <span class="name">专业:</span>
                            <el-input class="input" v-model="userInfo.profession_title" readonly placeholder=""></el-input>
                        </div>
                    </div>
                    <div class="table-box">
                        <table class="table-item">
                            <tbody>
                                <tr>
                                    <td class="cell table-name" rowspan="8">
                                        <p>学</p>
                                        <p>生</p>
                                        <p>本</p>
                                        <p>人</p>
                                        <p>基</p>
                                        <p>本</p>
                                        <p>情</p>
                                        <p>况</p>
                                    </td>
                                    <td class="cell name">姓名</td>
                                    <td class="cell" colspan="2">{{ userInfo.student_title }}</td>
                                    <td class="cell name">性别</td>
                                    <td class="cell">{{ userInfo.sex_title }}</td>
                                    <td class="cell name">民族</td>
                                    <td class="cell">{{ userInfo.nation }}</td>
                                    <td class="cell avatar" rowspan="5" style="width: 200px;">
                                        <el-image
                                            v-if="userInfo.admission_img"
                                            :src="userInfo.admission_img"
                                            fit="cover"
                                        ></el-image>
                                        <div v-else>
                                            <p>贴</p>
                                            <p>正</p>
                                            <p>面</p>
                                            <p>头</p>
                                            <p>像</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell required">政治面貌</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="political_status">
                                            <!-- placeholder="" -->
                                            <el-select v-model="formData.political_status" placeholder="请选择政治面貌" clearable filterable style="width: 100%;">
                                                <el-option
                                                    v-for="(item, index) in outlookList"
                                                    :key="index"
                                                    :label="item.title"
                                                    :value="item.id"
                                                    >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">学制</td>
                                    <td class="cell">{{ userInfo.education_length }}</td>
                                    <td class="cell" colspan="2"></td>
                                    <!-- <td class="cell" colspan="2">
                                        <el-form-item label="" prop="hkmo_tw_occupant">
                                            <el-radio-group v-model="formData.hkmo_tw_occupant">
                                                <el-radio label="1">港</el-radio>
                                                <el-radio label="2">澳</el-radio>
                                                <el-radio label="3">台</el-radio>
                                                <el-radio label="4">侨</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td class="cell">出生日期</td>
                                    <td class="cell" colspan="2">{{ userInfo.birth_date }}</td>
                                    <td class="cell" colspan="2">入学形式</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="admission_form">
                                            <el-radio-group v-model="formData.admission_form">
                                                <el-radio label="1">成人高考</el-radio>
                                                <el-radio label="2">其他</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </td>
                                    <!-- <td class="cell" colspan="2">健康状况</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="health_status">
                                            <el-radio-group v-model="formData.health_status">
                                                <el-radio label="1">健康</el-radio>
                                                <el-radio label="2">残疾</el-radio>
                                                <el-radio label="3">其他</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </td> -->
                                </tr>
                                <tr>
                                    <td class="cell">学历层次</td>
                                    <td class="cell" colspan="2">{{ userInfo.education_level_title }}</td>
                                    <td class="cell">身份证号</td>
                                    <td class="cell" colspan="7">{{ userInfo.id_card }}</td>
                                </tr>
                                <tr>
                                    <td class="cell required">入学前最高学历</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="pre_education">
                                            <el-input v-model="formData.pre_education" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell required" colspan="2">入学前毕业学校及专业</td>
                                    <td class="cell" colspan="3">
                                        <el-form-item label="" prop="pre_school_profession">
                                            <el-input v-model="formData.pre_school_profession" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell" rowspan="2">工作信息</td>
                                    <td class="cell" colspan="4">
                                        <el-form-item label="参加工作时间:" label-width="120px" prop="work_start_date">
                                            <el-date-picker
                                                v-model="formData.work_start_date"
                                                type="date"
                                                placeholder=""
                                                value-format="yyyy-MM-dd"
                                                style="width:100%" 
                                            >
                                            </el-date-picker>
                                        </el-form-item>
                                    </td>
                                    <td class="cell" colspan="3">
                                        <el-form-item label="现工作单位:" label-width="100px" prop="current_work_unit">
                                            <el-input v-model="formData.current_work_unit" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell" colspan="4">
                                        <el-form-item label="单位电话:" label-width="100px" prop="unit_phone">
                                            <el-input v-model="formData.unit_phone" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell" colspan="2">
                                        <div style="display: flex;">
                                            <el-form-item label="职务:" label-width="80px" prop="position">
                                                <el-input v-model="formData.position" clearable placeholder=""></el-input>
                                            </el-form-item>
                                            <el-form-item label="职称:" label-width="80px" prop="job_title">
                                                <el-input v-model="formData.job_title" clearable placeholder=""></el-input>
                                            </el-form-item>
                                        </div>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="邮编:" label-width="80px" prop="postal_code">
                                            <el-input v-model="formData.postal_code" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name" rowspan="3">
                                        <p>通</p>
                                        <p>讯</p>
                                        <p>录</p>
                                    </td>
                                    <td class="cell name required" rowspan="2" style="width: 100px;">详细通讯地址</td>
                                    <td class="cell" rowspan="2" colspan="5">
                                        <el-form-item label="" prop="detailed_address">
                                            <el-input v-model="formData.detailed_address" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell name">邮政编码</td>
                                    <td class="cell">
                                        <el-form-item label="" prop="address_postal_code">
                                            <el-input v-model="formData.address_postal_code" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell name required">电子邮箱</td>
                                    <td class="cell">
                                        <el-form-item label="" prop="email">
                                            <el-input v-model="formData.email" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell name">手机号</td>
                                    <td class="cell" colspan="2">
                                         {{ userInfo.mobile_phone }}
                                        <!-- <el-form-item label="" prop="mobile_phone">
                                            <el-input v-model="formData.mobile_phone" readonly clearable placeholder=""></el-input>
                                        </el-form-item> -->
                                    </td>
                                    <td class="cell name">座机</td>
                                    <td class="cell" colspan="2">
                                        <el-form-item label="" prop="landline">
                                            <el-input v-model="formData.landline" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell name required">QQ号</td>
                                    <td class="cell">
                                        <el-form-item label="" prop="qq_number">
                                            <el-input v-model="formData.qq_number" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name" :rowspan="formData.personal_resume.length + 1">
                                        <p>个</p>
                                        <p>人</p>
                                        <p>主</p>
                                        <p>要</p>
                                        <p>简</p>
                                        <p>历</p>
                                    </td>
                                    <td class="cell name" colspan="3">何年何月-何年何月</td>
                                    <td class="cell name" colspan="3">在何地工作或学习</td>
                                    <td class="cell name">任职情况</td>
                                    <td class="cell name">备注</td>
                                </tr>
                                <tr v-for="(item, index) in formData.personal_resume" :key="index">
                                    <td class="cell" colspan="3">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.time" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell" colspan="3">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.cont" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.situation" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.remark" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td class="cell table-name" :rowspan="formData.family_members.length + 1">
                                        <p>家</p>
                                        <p>庭</p>
                                        <p>成</p>
                                        <p>员</p>
                                        <p>情</p>
                                        <p>况</p>
                                    </td>
                                    <td class="cell name">姓名</td>
                                    <td class="cell name">年龄</td>
                                    <td class="cell name">关系</td>
                                    <td class="cell name" colspan="4">工作单位</td>
                                    <td class="cell name">联系电话</td>
                                </tr>
                                <tr v-for="(item, index) in formData.family_members" :key="index">
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.name" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.age" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.relationship" readonly clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell" colspan="4">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.employer" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell">
                                        <el-form-item label="" prop="">
                                            <el-input v-model="item.phone" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody>
                            <!-- <tbody>
                                <tr>
                                    <td class="cell name" colspan="3">有何特长、兴趣爱好,受过何种奖励、处分</td>
                                    <td class="cell" colspan="6">
                                        <el-form-item label="" prop="special_skills_interests">
                                            <el-input v-model="formData.special_skills_interests" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody> -->
                            <tbody>
                                <tr>
                                    <td class="cell" colspan="9">
                                        <div>本人知晓此表为高等学历继续教育学籍档案的重要组成部分，并郑重承诺：实事求是填写有关内容，对内容的真实性有效性负责。</div>
                                        <div class="esign-info-box">
                                            <div class="esign-box">
                                                <el-form-item label="学生签名：" label-width="120px" prop="sign_img">
                                                    <!-- this.$refs['esignHandle'].handleReset(); -->
                                                    <esignHandle
                                                        ref="esignHandle"
                                                        :selectSignImg.sync="formData.sign_img"
                                                    ></esignHandle>
                                                </el-form-item>
                                            </div>
                                            <div style="margin-top: 10px; text-align: right;">
                                                <span>填表时间:</span>
                                                <span style="margin-left: 10px;">{{ formData.fill_date }}</span>
                                                <!-- <el-form-item label="填表时间:" label-width="120px" prop="fill_date">
                                                    <el-date-picker
                                                        v-model="formData.fill_date"
                                                        type="date"
                                                        placeholder=""
                                                        value-format="yyyy-MM-dd"
                                                        style="width:100%" 
                                                    >
                                                    </el-date-picker>
                                                </el-form-item> -->
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell name" colspan="2">备 注</td>
                                    <td class="cell" colspan="5">
                                        <el-form-item label="" prop="remarks">
                                            <el-input v-model="formData.remarks" clearable placeholder=""></el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="cell" colspan="2" style="width: 282px;height: 80px;">
                                    <p class="chapter">重庆医科大学继续教育学院(教务与学生管理科)盖章</p>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="margin-top: 20px;text-align: center;padding-right: 50px;">重庆医科大学继续教育学院制</div>
                    </div>
                </el-form>
            </div>
            <div class="btn-box">
                <el-button type="primary" @click="confirmClick">提交</el-button>
                <el-button class="exit-btn" type="primary" @click="exit">退出登录</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {userRegPost, userRegInfo} from '@/api/login';
import esignHandle from '@/components/esignHandle';
import {deepClone, goFirstError, getCurrentTime} from '@/utils/func';
import {outlookData} from "@/utils/baseData";
export default {
    name: 'infoRegForm',
    components: { esignHandle },
    data(){
        return {
            outlookList: outlookData,
            userInfo: {},
            formData: {
                political_status: '',  //政治面貌
                // hkmo_tw_occupant: 0,  //港/澳/台/侨 0否 1港/2澳/3台/4侨
                // health_status: '',  //健康状况 1健康 2残疾 3其他
                admission_form: '',  //入学形式 1成人高考 2其他
                pre_education: '',  //入学前最高学历
                pre_school_profession: '',  //入学前毕业学校及专业
                work_start_date: '',  //参加工作时间
                current_work_unit: '',  //现工作单位
                position: '',  //职务
                job_title: '',  //职称
                postal_code: '',  //邮编
                detailed_address: '',  //详细通讯地址
                address_postal_code: '',  //邮政编码
                email: '',  //电子邮箱
                mobile_phone: '',  //手机号
                landline: '',  //座机
                qq_number: '',  //QQ号
                //个人主要简历
                personal_resume: [
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                    {time: '', cont: '', situation: '', remark: ''},
                ],  
                // 家庭成员情况
                family_members: [
                    {name: '', age: '', relationship: '夫妻', employer: '', phone: ''},
                    {name: '', age: '', relationship: '父亲', employer: '', phone: ''},
                    {name: '', age: '', relationship: '母亲', employer: '', phone: ''},
                    {name: '', age: '', relationship: '子女', employer: '', phone: ''},
                ],
                special_skills_interests: '',  //有何特长、兴趣爱好,受过何种奖励、处分
                remarks: '', // 备注
                sign_img: '',  // 签名
                fill_date: '',  // 填表时间
            },
            rules: {
                political_status: [{ required: true, message: '请选择政治面貌', trigger: 'change' }],
                // hkmo_tw_occupant: [{ required: true, message: '请选择港澳台侨', trigger: 'change' }],
                // health_status: [{ required: true, message: '请选择健康状况', trigger: 'change' }],
                admission_form: [{ required: true, message: '请选择入学形式', trigger: 'change' }],
                pre_education: [{ required: true, message: '请填写入学前最高学历', trigger: 'blur' }],
                pre_school_profession: [{ required: true, message: '请填写入学前毕业学校及专业', trigger: 'blur' }],
                // work_start_date: [{ required: true, message: '请选择参加工作时间', trigger: 'change' }],
                // current_work_unit: [{ required: true, message: '请填写现工作单位', trigger: 'blur' }],
                // position: [{ required: true, message: '请填写职务', trigger: 'blur' }],
                // job_title: [{ required: true, message: '请填写职称', trigger: 'blur' }],
                // postal_code: [{ required: true, message: '请填写邮编', trigger: 'blur' }],
                detailed_address: [{ required: true, message: '请填写详细通讯地址', trigger: 'blur' }],
                // address_postal_code: [{ required: true, message: '请填写邮政编码', trigger: 'blur' }],
                email: [{ required: true, message: '请填写电子邮箱', trigger: 'blur' }],
                mobile_phone: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
                // landline: [{ required: true, message: '请填写座机', trigger: 'blur' }],
                qq_number: [{ required: true, message: '请填写QQ号', trigger: 'blur' }],
                personal_resume: [{ required: true, message: '请填写个人简历', trigger: 'blur' }],
                // special_skills_interests: [{ required: true, message: '请填写有何特长、兴趣爱好,受过何种奖励、处分', trigger: 'blur' }],
                // remarks: [{ required: true, message: '请填写备注', trigger: 'blur' }],
                sign_img: [{ required: true, message: '请填写签名', trigger: 'blur' }],
                // fill_date: [{ required: true, message: '请填写填表时间', trigger: 'blur' }],
            },
        };
    },
    computed: {
        ...mapState("permission", {
            _ENTRANCETYPE: (state) => state._ENTRANCETYPE,  //成教/自考
            enterConfirm: state => state.enterConfirm,   //是否确认信息
            firstLoginVerify: state => state.firstLoginVerify,  //是否第一次登录
            userInfoData: state => JSON.parse(state.userInfo),  //用户信息
            enterSchoolImgCheck: state => state.enterSchoolImgCheck,  //入学照审核状态
        }),
    },
    created(){
        this.getData();
    },
    methods: {
        // 退出
        async exit() {
            // loginOut(null).then(() => {
            // this.$store.dispatch('permission/setIsGenerateRoutes', '');
            await this.$store.dispatch('permission/logOut');
            // Cookies.remove('token');
            this.$message.success('退出成功');
            this.$router.replace("/Login");

            // });
        },
        // 提交
        confirmClick(){
             this.$refs["form"].validate(async (valid) => {
                if (valid) {
                    const data = deepClone(this.formData);
                    data.personal_resume = JSON.stringify(data.personal_resume);
                    data.family_members = JSON.stringify(data.family_members);
                    userRegPost(data).then(res => {
                        if(res.code == 200){
                            this.$message.success('操作成功');
                            this.$store.dispatch('permission/isRegistrationActions', 1);
                            this.$router.push({
                                name: "home",
                            });
                        }
                    });
                }else{
                    goFirstError();
                }
            });
        },
        getData() {
            userRegInfo().then(res => {
                if (res.code == 200) {
                    this.userInfo = res.result;
                    this.formData.mobile_phone = this.userInfo.mobile_phone;
                    this.formData.fill_date = getCurrentTime(true, 'Y年M月D日');
                    if(!!this.userInfo.political_status){
                        this.formData.political_status = this.userInfo.political_status;
                    }
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.infoRegForm{
    padding: 20px;
    font-size: 16px;
    .info{
        background-color: #fff;
        padding: 20px;
        width: 1200px;
        margin: 0 auto;
        .info-box{
            .title-box{
                font-size: 24px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 20px;
            }
            .info-floor{
                display: flex;
                align-items: center;
                & + .info-floor{ 
                    margin-top: 20px;
                }
                .item{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    & + .item{
                        margin-left: 20px;
                    }
                    .name{
                        flex-shrink: 0;
                    }
                    .input{
                        margin-left: 10px;
                    }
                }
            }
            .table-box{
                margin-top: 20px;
                .table-item{
                    width: 100%;
                    .cell{
                        padding: 5px;
                        min-width: 100px;
                        &.table-name{
                            width: 40px;
                             min-width: 40px;
                            p{
                                text-align: center;
                            }
                        }
                        &.avatar{
                            width: 160px;
                            p{
                                text-align: center;
                            }
                        }
                        &.required{
                            &::before{
                                content: '*';
                                color: #EF3333;
                                margin-right: 4px
                            }
                        }
                        .esign-info-box{
                            margin-top: 10px;
                            padding-right: 20px;
                            .esign-box{
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                            }
                        }
                        .chapter{
                            padding: 0 30px;
                            text-align: center;
                        }
                    }
                }
            }
        }
        .btn-box{
            margin-top: 20px;
            text-align: center;
        }
    }
}
</style>

<style lang="scss">
.infoRegForm{
    .info-floor{
        .el-input{
            .el-input__inner{
                border: none;
                border-bottom: 1px solid #DCDFE6;
            }
        }
    }
    table, th, td {
        border: 1px solid #ccc;
        border-collapse: collapse;
    }
}
</style>